import {Button, Checkbox, Form, Icon, Label, Select} from "semantic-ui-react";
import React, {useEffect, useMemo, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {useAppDispatch, useAppSelector} from "../../../hooks/hooks";
import {clearSingleUserState, createModeHandler, editModeHandler, getRoles} from "./UsersCRUD.slice";
import {IUserPayload, IUserFormData, IRole} from "./UsersCRUD.types";
import {createUserPayload} from "./helpers/createPayload";
import {setUserHandler} from "./helpers/hasExistingUser";
import { api } from "../../../services/api/api.service";
import styles from "./UsersCRUD.module.scss"
import Permissions from "../../../components/Permissions/Permissions";
//import {readUserPermissions,} from "../../../store/cms/permissions/permissionsSlice";

const UsersCRUDForm = () => {
    const dispatch = useAppDispatch();
    const { roles, allUsers, user, editMode, allClients, clientId } = useAppSelector(state => state.UsersCRUD);
    const {permissions} = useAppSelector(state => state.permissions)
    const { register, control, handleSubmit, formState: { errors }, setValue } = useForm<IUserFormData> ({
        defaultValues: {
            userName: user?.name ?? '',
            userEmail: user?.email ?? '',
            userRole: user?.roles[0] ?? ''
        }
    });
    const [newClient, setNewClient] = useState<any>(undefined);
    const [is2FA, setIs2FA] = useState(false);
    const [selectedPermissions, setSelectedPermissions] = useState<string[]>([]);

    useEffect(() => {
        if (editMode && user.roles) {
            setUpdatingUserInfo(user.id)
            setValue('userRole', user.roles[0] ?? '')
            setIs2FA(user.is2FA)
            readExistingPermission(user.id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user])

    useEffect(() => {
        if (clientId) {
            setNewClient(clientId)
        }
        dispatch(getRoles())
    }, [clientId,dispatch]);

    const readExistingPermission = (id: number) => {
        //ToDo: ���������������� Permissions �� �����
    //    dispatch(readUserPermissions(id)).then((data: {
    //        payload: {codes: React.SetStateAction<string[]>;}}) => {
    //        setSelectedPermissions(data.payload.codes)
    //    })
    }

    const setUpdatingUserInfo = async (userId: number) => {
        //ToDo: ������������ TryCatch
        try {
            const {data} = await api.get(`/api/users/${userId}`)
            if (data.clientId) {
                setNewClient(data.clientId)
            }
        } catch {}
    }

    const roleNames = useMemo(() => {
        return roles.map((role: IRole) => ({
            key: role.id,
            value: role.name,
            text: role.name,
        }))
    }, [roles])

    const onSubmit = (inputData: IUserFormData) => {
        if (editMode) {
            const payload: IUserPayload = createUserPayload({
                inputData,
                roles,
                userId: user.id,
                clientId: newClient,
                is2FA,
                permissions: selectedPermissions
            })

            setUserHandler({user: payload, allUsers, dispatch, editMode, editedUser: user})
        }
        if (!editMode) {
            const payload: IUserPayload = createUserPayload({
                inputData,
                roles,
                clientId:
                newClient,
                is2FA,
                permissions: selectedPermissions
            });
            setUserHandler({user: payload, allUsers, dispatch, editMode, editedUser: user});
        }
    }

    const closeForm = () => {
        dispatch(createModeHandler(false));
        dispatch(editModeHandler(false));
        dispatch(clearSingleUserState());
    }

    const clientOptions = useMemo(() => {
        //ToDo: Clients ����� ��� �������� User ��������������� �������� ��� �����-�������
        //const clients = allClients.map(client => {
        //    return {key: client.id, value: client.id, text: client.name}
        //})
        //clients.unshift({key: 0, value: 0, text: "Unselected"})
        const clients = { key: 0, value: 0, text: "Unselected" }
        return [clients]
    }, [allClients]);

    const selectPermission = (permission: string) => {
        const isExistPermission = selectedPermissions.find(item => item === permission)
        if (isExistPermission) {
            return setSelectedPermissions(selectedPermissions.filter(item => item !== permission))
        } else {
            setSelectedPermissions([...selectedPermissions, permission])
        }
    }

    return (
        <div className="form-overlay-general">
            <Form autoComplete={"off"} onSubmit={handleSubmit(onSubmit)} className={"darts-users-form"}>
                <Icon color="red" name="close" size="large" onClick={closeForm} style={{float: "right", cursor: "pointer"}} />
                <div className={styles.formRow}>
                    <Form.Field className={styles.formField}>
                        <Label className="darts-users-form-label">Client</Label>
                        <Select
                            name={"clientId"}
                            options={clientOptions}
                            value={newClient}
                            onChange={(e, {value}) => {
                                setNewClient(value)
                            }}
                            placeholder='Select client'
                        />
                    </Form.Field>
                    <Form.Field className={styles.formField}>
                        <Label className="darts-users-form-label">Name</Label>
                        <input autoComplete="new-user" defaultValue={user.name} {...register("userName", {required: true, minLength: 3})} />

                        {errors.userName && errors.userName.type === 'required' &&
                            <div className={'darts-users-form-error-wrap'}>
                                <div><i className="warning sign red icon"></i></div>
                                <p className='darts-users-form-error'>The user name field is required</p>
                            </div>}
                        {errors.userName && errors.userName.type === 'minLength' &&
                            <div className={'darts-users-form-error-wrap'}>
                                <div><i className="warning sign red icon"></i></div>
                                <p className='darts-users-form-error'>This field required min 3 symbols</p>
                            </div>}
                    </Form.Field>
                </div>
                <div className={styles.formRow}>
                    <Form.Field className={styles.formField}>
                        <Label className="darts-users-form-label">E-mail</Label>
                        <input type={'email'} defaultValue={user.email} {...register("userEmail", { required: true, minLength: 5, pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i })} />
                        {errors.userEmail && errors.userEmail.type === 'required' &&
                            <div className={'darts-users-form-error-wrap'}>
                                <div><i className="warning sign red icon"></i></div>
                                <p className='darts-users-form-error'>The user e-mail field is required</p>
                            </div>}
                        {errors.userEmail && errors.userEmail.type === 'minLength' &&
                            <div className={'darts-users-form-error-wrap'}>
                                <div><i className="warning sign red icon"></i></div>
                                <p className='darts-users-form-error'>This field required min 5 symbols</p>
                            </div>
                        }
                        {errors.userEmail && errors.userEmail.type === 'pattern' &&
                            <div className={'darts-users-form-error-wrap'}>
                                <div><i className="warning sign red icon"></i></div>
                                <p className='darts-users-form-error'>The e-mail should be like example@domain.com</p>
                            </div>
                        }
                    </Form.Field>
                    <Form.Field className={styles.formField}>
                        <Label className="darts-users-form-label">Role</Label>
                            <Controller
                                    name="userRole"
                                    control={control}
                                    rules={{
                                        validate: (value) => {
                                            return !!(value && value.length > 0)
                                        }
                                    }}
                                    render={({ field }) => (
                                        <Select multiple id="userRole" options={roleNames} placeholder="Select user role" {...field} />
                                    )}
                                />
                        {errors.userRole && errors.userRole.type === 'validate' &&
                            <div className={'darts-users-form-error-wrap'}>
                                <div><i className="warning sign red icon"></i></div>
                                <p className='darts-users-form-error'>The user's role field is required</p>
                            </div>}
                    </Form.Field>
                </div>
                <div className={"two-factor-checkbox"}>
                    <Checkbox
                        checked={is2FA}
                        onClick={() => setIs2FA(!is2FA)}
                        label={"Two factor authorization."}
                    />
                </div>
                <Permissions
                    title={"Permissions"}
                    permissions={permissions}
                    selectedPermissions={selectedPermissions}
                    selectPermission={selectPermission}
                />
                <Button id="save_game" color="green" type="submit">
                    {editMode ? 'Update' : 'Create'}
                </Button>
            </Form>
        </div>
    );
}

export default UsersCRUDForm;
